
$(document).ready(function (){
    var countProject=$('.project').length;
    if(countProject<=0){
        $(".related-program").hide();
    }else{
        if(countProject>2){
            var listProgram = new Swiper('.related-program-list', {
                slidesPerView: 1,
                loop:true,
                autoplay: {
                    delay: 10000,
                },
                spaceBetween: 30,
                breakpoints: {
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    },
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    }
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }else{
            var listProgram = new Swiper('.related-program-list', {
                slidesPerView: 1,
                loop:false,
                autoplay: {
                    delay: 10000,
                },
                spaceBetween: 30,
                breakpoints: {
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    },
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    }
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }
    }

    var countBenefit=$('.benefit-content').length;
    if(countBenefit<=0){
        $(".benefit").hide();
    }
    $(document).on('click', '#load-more', function() {
        let url = $(this).data('route');
        let page = $('#load-more').attr('data-page');
        apibenefit(url,{
            page:page
        }).done(function (res) {
            if (res.data && res.data.length>0){
                let items='';
                $.each(res.data,function (index,item){
                    items+=renderBenefit(item)
                })
                console.log(items);
                $('#list-benefits').append(items);
                $('#load-more').attr('data-page',res.current_page)
                if (res.data.length>=0 && res.data.length<6){
                    $('#load-more').hide()
                }
                if(res.to === res.total){
                    $('#load-more').hide()
                }
            }
            else {
                $('#load-more').hide()
            }
            

        })
            .fail(function(jqXHR, ajaxOptions, thrownError) {

            });
    });

    function renderBenefit(item){
        return `
            <div class="col-lg-4 col-md-4 col-sm-6 sb-4">
                <div class="benefit-content text-center">
                    <div class="icon-image">
                        <img src= "${item.icon_img?'/'+item.icon_img:'/images/course/benefit.png'}"
                        alt="${item.title_en}" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">${item.title_en}</h4>
                        <div class="text-body">
                            <p>${item.text_en}</p>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
})
